import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import OutboundLink from '../../../common/OutboundLink';
import Ad from '../../../Ad';
import { APP_ENV } from '../../../../consts';
import { getFileName, isValid, isText, decodeTags, segmentTrackEvent, decodeSpecialCharacters, getRelValue } from '../../../../utils';
import { PinterestShareButton } from 'react-share';

const ArticleSlide = ({
  data,
  articleLayout,
  currentSlide,
  fullUrl=null,
  handleLinkClick,
  handleRelatedStory,
  seo,
}) => {
  if (!isValid(data)) { return null; }
  const {
    imageSrcDesktop,
    imageSrcMobile,
    imageAlt,
    credit,
    creditUrl,
    button,
    usePinterest = true,
    imagePinterestOverride,
  } = data;

  const isStandard = (articleLayout === 'Standard');
  const slideHedClass = isStandard ? 'slide-hed standard' : 'slide-hed';
  const slideBtnWrapClass = isStandard ? 'slide-button-wrapper standard' : 'slide-button-wrapper';
  const slideCTAClass = isStandard ? 'slide-cta button-text standard' : 'slide-cta button-text';

  const imageSrc = isValid(imageSrcMobile) ? imageSrcMobile : isValid(imageSrcDesktop) ? imageSrcDesktop : null;
  const imgAlt = isText(imageAlt) ? imageAlt : getFileName(imageSrc);
  let hed = decodeTags(data.hed);
  const text = decodeTags(data.text);
  const hedUrl = hed && hed.includes('href') ? hed.split('href="').pop().split('"')[0] : null; 
  const slideNum = currentSlide + 1;
  hed = `${slideNum}. ${hed}`;

  let buttonUrl = null;
  let buttonText = null;

  if (isValid(button)) {
    buttonUrl = decodeSpecialCharacters(button.buttonUrl);
    buttonText = button.buttonText;
  }

  if (!isText(buttonText)) {
    buttonText = 'Buy Now';
  }
  const imgUrl = isValid(buttonUrl) ? buttonUrl : hedUrl;
  const imgUrlRel = getRelValue(imgUrl);
  const pinBtnClass = isText(credit) ? "pin-btn credit" : "pin-btn";
  const pinMedia = isValid(imagePinterestOverride) ? imagePinterestOverride : imageSrc;
  const showPin = Boolean(fullUrl && pinMedia);
  const renderedCopyBuy = (
    <div className={slideBtnWrapClass} onClick={() => segmentTrackEvent('slideshow', { label: `slide_${currentSlide + 1}`, action: 'click',})}>
      <OutboundLink className={slideCTAClass} href={buttonUrl} rel={imgUrlRel} dataLinkType="shop-link" >
        {buttonText}
      </OutboundLink>
    </div>
  );

  let relatedLinkBodyText;
  let bodyTextAfterRelatedLink;
  let justBodyText;
  let slideText;
  const relatedTag = '<p class="related-story-link">';
  const hasRelatedStoryLink = text.includes(relatedTag);
  const slideCopyClass = buttonUrl ? "slide-copy-container has-button" : "slide-copy-container";
  if (isText(text) && hasRelatedStoryLink) {
    const relatedStoryData = handleRelatedStory(text);
    relatedLinkBodyText = relatedStoryData.relatedLinkBodyText || null;
    bodyTextAfterRelatedLink = relatedStoryData.bodyTextAfterRelatedLink || null;
    justBodyText = relatedStoryData.justBodyText || null;
  }

  {hasRelatedStoryLink ? (
    slideText = 
    <Fragment>
      <div className="slide-text" dangerouslySetInnerHTML={ { __html: justBodyText } } onClick={e => handleLinkClick(e)}/>
      <div className="related-story-link-container">
        <div className="related-header">
          <strong>RELATED</strong>
          <hr></hr>
        </div>
        <div className='body-text' dangerouslySetInnerHTML={ { __html: relatedLinkBodyText } } onClick={e => handleLinkClick(e)}/>
        <hr></hr>
      </div>
      {(isValid(bodyTextAfterRelatedLink))
        && <div className='slide-text' dangerouslySetInnerHTML={ { __html: bodyTextAfterRelatedLink } } />
      }
    </Fragment>
  ) : (
    slideText = 
    <Fragment>
      <div className="slide-text" dangerouslySetInnerHTML={ { __html: text } } onClick={e => handleLinkClick(e)}/>
    </Fragment>
  )}

  return (
    <div className="article-slide">
      <div className="slide-img-container">
        { imgUrl ? (
          <a target="_blank" href={imgUrl} data-link-type="image-link">
            <img className="slide-img" src={imageSrc} alt={imgAlt} />
          </a>
        ) : (
          <img className="slide-img" src={imageSrc} alt={imgAlt} />
        )}
        {usePinterest && showPin && 
          <div className="social-pin-wrapper">
            <PinterestShareButton
              className="social-share-unit pinterest"
              onClick={() => segmentTrackEvent('pinterest_share', {action: 'social', label: 'pin_share'})}
              url={fullUrl}
              alt={imgAlt || 'pinterest share image'}
              description={seo.metaDescription}
              media={pinMedia || 'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
            </PinterestShareButton>
          </div>  
        }
        { isText(creditUrl) ? (
            <div className="slide-img-credit"><a href={decodeSpecialCharacters(creditUrl)} target="_blank" data-link-type="credit-link">{credit}</a></div>
          ) : (
            <div className="slide-img-credit">{credit}</div>
          )

        }
      </div>
      <div className="slide-content">
        <div id="slide-copy" className={slideCopyClass}>
          <h2 className={slideHedClass}><span dangerouslySetInnerHTML={ { __html: hed } } onClick={e => handleLinkClick(e)}/></h2>
          {slideText}
          { buttonUrl && renderedCopyBuy }
        </div>
      </div>
    </div>
  );
};

ArticleSlide.propTypes = {
  data: PropTypes.object,
};


export default ArticleSlide;